import { getters } from '@/modules/core/app/helpers/store';
import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { AppModule } from '@/modules/core/app/constants/app.constants';

export class LogRouteConfig extends PageRouteConfig {
  /**
   * @override
   * @returns {boolean}
   */
  canAccessRouteFromContext() {
    const userSettings = getters.session.getUserSettings();
    return (
      userSettings.isModuleAvailable(AppModule.IO_TOOL_STELLAR_SYNC) && userSettings.isSuperAdmin()
    );
  }
}
